var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "511pt",
    viewBox: "1 0 511.99999 511",
    width: "511pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 336.667969 308.453125 C 328.40625 308.453125 321.695312 301.765625 321.671875 293.496094 C 321.644531 285.214844 328.339844 278.476562 336.625 278.453125 C 374.304688 278.335938 410.152344 255.585938 437.5625 214.390625 C 463.871094 174.851562 479.328125 123.144531 481.683594 67.453125 L 415.613281 67.453125 C 407.328125 67.453125 400.613281 60.738281 400.613281 52.453125 C 400.613281 44.167969 407.328125 37.453125 415.613281 37.453125 L 497 37.453125 C 505.285156 37.453125 512 44.167969 512 52.453125 C 512 119.664062 494.433594 183.074219 462.542969 231.011719 C 429.410156 280.800781 384.726562 308.304688 336.71875 308.453125 C 336.703125 308.453125 336.6875 308.453125 336.667969 308.453125 Z M 336.667969 308.453125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,55.686275%,11.372549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 175.332031 308.453125 C 175.3125 308.453125 175.300781 308.453125 175.285156 308.453125 C 127.277344 308.304688 82.589844 280.800781 49.460938 231.011719 C 17.566406 183.074219 0 119.664062 0 52.453125 C 0 44.167969 6.714844 37.453125 15 37.453125 L 96.386719 37.453125 C 104.671875 37.453125 111.386719 44.167969 111.386719 52.453125 C 111.386719 60.738281 104.671875 67.453125 96.386719 67.453125 L 30.316406 67.453125 C 32.671875 123.144531 48.128906 174.851562 74.4375 214.390625 C 101.847656 255.585938 137.695312 278.335938 175.375 278.453125 C 183.660156 278.476562 190.355469 285.214844 190.328125 293.496094 C 190.304688 301.765625 183.59375 308.449219 175.332031 308.453125 Z M 175.332031 308.453125 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.019608%,13.72549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 416.667969 0.5 L 95.332031 0.5 C 87.050781 0.5 80.332031 7.214844 80.332031 15.5 C 80.332031 103.613281 97.609375 186.691406 128.976562 249.425781 C 149.074219 289.617188 173.652344 318.792969 200.832031 335.496094 L 200.832031 417.164062 C 200.832031 425.449219 207.550781 432.164062 215.832031 432.164062 L 296.167969 432.164062 C 304.453125 432.164062 311.167969 425.449219 311.167969 417.164062 L 311.167969 335.496094 C 338.347656 318.796875 362.929688 289.617188 383.023438 249.425781 C 414.390625 186.691406 431.667969 103.613281 431.667969 15.5 C 431.667969 7.214844 424.953125 0.5 416.667969 0.5 Z M 416.667969 0.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,81.960784%,16.862745%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 311.167969 417.164062 L 311.167969 335.496094 C 338.347656 318.796875 362.929688 289.617188 383.023438 249.425781 C 414.390625 186.691406 431.667969 103.613281 431.667969 15.5 C 431.667969 7.214844 424.953125 0.5 416.667969 0.5 L 256 0.5 L 256 432.164062 L 296.167969 432.164062 C 304.453125 432.164062 311.167969 425.449219 311.167969 417.164062 Z M 311.167969 417.164062 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.019608%,13.72549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.332031 402.164062 L 175.667969 402.164062 C 145.25 402.164062 120.5 426.914062 120.5 457.332031 L 120.5 497.5 C 120.5 505.78125 127.214844 512.496094 135.5 512.496094 L 376.5 512.496094 C 384.785156 512.496094 391.5 505.78125 391.5 497.5 L 391.5 457.332031 C 391.5 426.914062 366.753906 402.164062 336.332031 402.164062 Z M 336.332031 402.164062 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,55.686275%,11.372549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 336.332031 402.164062 L 256 402.164062 L 256 512.496094 L 376.5 512.496094 C 384.785156 512.496094 391.5 505.78125 391.5 497.5 L 391.5 457.332031 C 391.5 426.914062 366.753906 402.164062 336.332031 402.164062 Z M 336.332031 402.164062 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,42.745098%,8.235294%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 392.566406 512.496094 L 119.433594 512.496094 C 111.152344 512.496094 104.433594 505.78125 104.433594 497.5 C 104.433594 489.214844 111.152344 482.5 119.433594 482.5 L 392.566406 482.5 C 400.851562 482.5 407.566406 489.214844 407.566406 497.5 C 407.566406 505.78125 400.851562 512.496094 392.566406 512.496094 Z M 392.566406 512.496094 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,69.019608%,13.72549%)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 392.566406 482.5 L 256 482.5 L 256 512.496094 L 392.566406 512.496094 C 400.851562 512.496094 407.566406 505.78125 407.566406 497.5 C 407.566406 489.214844 400.851562 482.5 392.566406 482.5 Z M 392.566406 482.5 ",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,55.686275%,11.372549%)",
      fillOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e629f032e26db2e6632e35abfb8fddda.svg";
export { ForwardRef as ReactComponent };